__turbopack_export_value__({
  "body-logo-18": "HeaderNav-module-scss-module__oHV4AW__body-logo-18",
  "body-text-12": "HeaderNav-module-scss-module__oHV4AW__body-text-12",
  "body-text-14": "HeaderNav-module-scss-module__oHV4AW__body-text-14",
  "body-text-16": "HeaderNav-module-scss-module__oHV4AW__body-text-16",
  "body-text-18": "HeaderNav-module-scss-module__oHV4AW__body-text-18",
  "body-text-20": "HeaderNav-module-scss-module__oHV4AW__body-text-20",
  "body-text-24": "HeaderNav-module-scss-module__oHV4AW__body-text-24",
  "body-text-24-2": "HeaderNav-module-scss-module__oHV4AW__body-text-24-2",
  "body-text-heading-2": "HeaderNav-module-scss-module__oHV4AW__body-text-heading-2",
  "body-text-heading-3": "HeaderNav-module-scss-module__oHV4AW__body-text-heading-3",
  "body-text-medium-14": "HeaderNav-module-scss-module__oHV4AW__body-text-medium-14",
  "body-text-medium-16": "HeaderNav-module-scss-module__oHV4AW__body-text-medium-16",
  "body-text-medium-18": "HeaderNav-module-scss-module__oHV4AW__body-text-medium-18",
  "body-text-medium2-18": "HeaderNav-module-scss-module__oHV4AW__body-text-medium2-18",
  "body-text2-14": "HeaderNav-module-scss-module__oHV4AW__body-text2-14",
  "body-text2-16": "HeaderNav-module-scss-module__oHV4AW__body-text2-16",
  "burgerDropdown": "HeaderNav-module-scss-module__oHV4AW__burgerDropdown",
  "burgerDropdown__item": "HeaderNav-module-scss-module__oHV4AW__burgerDropdown__item",
  "burgerDropdown_opened": "HeaderNav-module-scss-module__oHV4AW__burgerDropdown_opened",
  "button-primary-text": "HeaderNav-module-scss-module__oHV4AW__button-primary-text",
  "button-text": "HeaderNav-module-scss-module__oHV4AW__button-text",
  "button2-text": "HeaderNav-module-scss-module__oHV4AW__button2-text",
  "card-shadow": "HeaderNav-module-scss-module__oHV4AW__card-shadow",
  "effect-menu": "HeaderNav-module-scss-module__oHV4AW__effect-menu",
  "header-1": "HeaderNav-module-scss-module__oHV4AW__header-1",
  "main-container": "HeaderNav-module-scss-module__oHV4AW__main-container",
  "main-footer-container": "HeaderNav-module-scss-module__oHV4AW__main-footer-container",
  "main-header-container": "HeaderNav-module-scss-module__oHV4AW__main-header-container",
  "nav": "HeaderNav-module-scss-module__oHV4AW__nav",
  "nav__item": "HeaderNav-module-scss-module__oHV4AW__nav__item",
  "nav__item_desktop": "HeaderNav-module-scss-module__oHV4AW__nav__item_desktop",
  "nav__item_hidden": "HeaderNav-module-scss-module__oHV4AW__nav__item_hidden",
  "nav__item_last": "HeaderNav-module-scss-module__oHV4AW__nav__item_last",
  "nav__link": "HeaderNav-module-scss-module__oHV4AW__nav__link",
  "nav__link_active": "HeaderNav-module-scss-module__oHV4AW__nav__link_active",
  "nav__list": "HeaderNav-module-scss-module__oHV4AW__nav__list",
  "txt-12-bold": "HeaderNav-module-scss-module__oHV4AW__txt-12-bold",
  "txt-14-bold": "HeaderNav-module-scss-module__oHV4AW__txt-14-bold",
  "txt-14-bold-caps": "HeaderNav-module-scss-module__oHV4AW__txt-14-bold-caps",
  "txt-14-med": "HeaderNav-module-scss-module__oHV4AW__txt-14-med",
  "txt-16-bold": "HeaderNav-module-scss-module__oHV4AW__txt-16-bold",
  "txt-16-med": "HeaderNav-module-scss-module__oHV4AW__txt-16-med",
  "txt-18-bold": "HeaderNav-module-scss-module__oHV4AW__txt-18-bold",
  "txt-18-medium": "HeaderNav-module-scss-module__oHV4AW__txt-18-medium",
  "txt-18-medium-24": "HeaderNav-module-scss-module__oHV4AW__txt-18-medium-24",
  "txt-24-semi": "HeaderNav-module-scss-module__oHV4AW__txt-24-semi",
});
